module.exports = __webpack_public_path__ + "img/51.9670a3f9.jpeg";